/**
 * Maximum zoom level at which clusters will be displayed. At zoom levels
 * greater than VISIBLE_CLUSTER_ZOOM_LIMIT, locations will be displayed.
 * @constant {number}
 */
export const VISIBLE_CLUSTER_ZOOM_LIMIT = 13

export const MIN_GEOLOCATION_ZOOM = 15
export const MIN_LOCATION_ZOOM = 18

/**
 * Default zoom level when navigating to a geolocation on the map
 * @constant {number}
 */
export const DEFAULT_GEOLOCATION_ZOOM = 16
